import classNames from 'classnames';

interface SelectMenuProps {
  children?: React.ReactNode;
  twoColumns?: boolean;
  threeColumns?: boolean;
  fourColumns?: boolean;
  fiveColumns?: boolean;
}

export default function SelectMenu({
  children,
  twoColumns,
  fourColumns,
  fiveColumns
}: SelectMenuProps) {
  return (
    <div
      className={classNames({
        'select-menu': true,
        'select-menu--twoColumns': twoColumns,
        'select-menu--fourColumns': fourColumns,
        'select-menu--fiveColumns': fiveColumns
      })}
    >
      {children}
    </div>
  );
}
